import type { TableHeaderSpec } from '@/@vxapp/@Types/ServiceMetadata'
import { ProductCategoryField } from '@/@vxapp/@Enums/PHP/ServicesV2/Products/Categories/DataProviders/ProductCategoryField'

export const ProductCategoriesTableHeaders = [
  {
    title: '#ID',
    align: 'start',
    key: 'id',
    placeholder: '00000',
  },
  {
    title: 'Name',
    align: 'start',
    key: ProductCategoryField.CATEGORY_NAME,
    sortable: false,
    placeholder: 'Category Name',
  },
  {
    title: 'Parent Category',
    align: 'start',
    key: ProductCategoryField.PARENT_CATEGORY_GUID,
    sortable: false,
    placeholder: 'Parent Category',
  },
  {
    title: 'Tag Line',
    align: 'start',
    key: ProductCategoryField.TAG_LINE,
    sortable: false,
    placeholder: 'Tag Line',
  },
  {
    title: 'Display Order',
    align: 'start',
    key: ProductCategoryField.DISPLAY_ORDER,
    sortable: false,
    placeholder: '1000',
  },
  {
    title: 'Actions',
    align: 'end',
    key: 'actions',
    sortable: false,
  },
] as const satisfies readonly TableHeaderSpec[]
